export default "__VITE_ASSET__FKNdLzKnlftW3t_gzo81yw__$_?url=true__"